import { redirectTypes } from '../types';

const initialState = {
    redirectTo: null,
};

export const redirect = (state = initialState, action) => {
    switch (action.type) {
        case redirectTypes.REDIRECT:
            return { redirectTo: action.redirectTo };

        case redirectTypes.CLEAR:
            return {
                ...initialState,
            };

        default:
            return state;
    }
};
